import gql from 'graphql-tag';
export const CREATE_ASSIGNMENT_PLAYLIST = gql`
  mutation CREATE_ASSIGNMENT_PLAYLIST(
    $assignedTo: AssignedToInput!
    $yml: String!
  ) {
    assignPlaylist(assignedTo: $assignedTo, yml: $yml){ _id }
  }
`;
export const LOAD_ASSIGNMENT = gql`
  query LOAD_ASSIGNMENT($id: MongoID!) {
    assignments(filter: { _id: $id }) {
      _id
      label: name
      classID
      assignedTo
      startDate
      endDate
      createdAt
      tasks {
        order
        instructions
        language
        contentID
        content {
          name
          previewURL
        }
      }
      work {
        userID
        work {
          taskID
          timestamp
        }
      }
    }
  }
`;
export const CREATE_ASSIGNMENT = gql`
  mutation CREATE_ASSIGNMENT(
    $classID: ID!
    $assignedTo: [ID!]!
    $label: String!
    $startDate: Date!
    $endDate: Date!
    $tasks: [TaskInput!]!
  ) {
    assignmentCreateOne(
      record: {
        name: $label
        classID: $classID
        assignedTo: $assignedTo
        startDate: $startDate
        endDate: $endDate
        tasks: $tasks
      }
    ) {
      recordId
      error {
        message
        ... on ValidationError {
          errors {
            message
            path
            value
          }
        }
      }
    }
  }
`;
export const UPDATE_ASSIGNMENT = gql`
  mutation UPDATE_ASSIGNMENT(
    $id: MongoID!
    $assignedTo: [ID!]!
    $label: String!
    $startDate: Date!
    $endDate: Date!
    $tasks: [UpdateByIdTaskInput!]
  ) {
    assignmentUpdateById(
      _id: $id
      record: {
        name: $label
        assignedTo: $assignedTo
        startDate: $startDate
        endDate: $endDate
        tasks: $tasks
      }
    ) {
      error {
        message
      }
    }
  }
`;
export const DELETE_ASSIGNMENT = gql`
  mutation DELETE_ASSIGNMENT($id: MongoID!) {
    assignmentRemoveById(_id: $id) {
      error {
        message
      }
    }
  }
`;